<template>
    <div v-if="loaded" class="toggle-switch">
        <input type="radio" :name="name" :id="getId()" :checked="active" v-on:click="onClick" /><label :for="getId()">{{ label }}</label>
    </div>
</template>

<script>

import { store } from './store.js'

export default {
    name: 'ToggleSwitch',
    data() {
        return {
            active: false,
            loaded: false,
            store,
        };
    },
    props: ['id', 'name', 'label', 'selected'],
    watch: {
        'store.activeToggle': function() {
            if(this.id === this.store.activeToggle) {
                this.active = true;
            } else {
                this.active = false;
            }
        }
    },
    mounted: function() {
        if(this.selected) {
            if(!this.store.activeToggle ) {
                this.store.activeToggle = this.id;
            }

            this.active = true;
        } else {
            if(!this.store.inactiveToggle ) {
                this.store.inactiveToggle = this.id;
            }
        }

        this.loaded = true;
    },
    methods: {
        onClick(e) {
            if(!this.active) {
                this.store.inactiveToggle = this.store.activeToggle;
                this.store.activeToggle = this.id;
            } else {
                this.store.activeToggle = this.store.inactiveToggle;
                this.store.inactiveToggle = this.id;
            }
        },
        getId() {
            return `${this.name}-${this.id}`;
        }
    }
};
</script>